/*
 * Mobile menu drawer: syncs nested collapsible panels with full-height min-heights,
 * parent overflow, scroll reset, and same-level sibling class toggling.
 *
 * HTML usage (snippets/menu-drawer.liquid):
 * <menu-drawer class="menu-drawer ...">
 *   <collapsible-element class="menu-drawer__inner">...</collapsible-element>
 * </menu-drawer>
 */

if (!customElements.get('menu-drawer')) {
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-collapsible-trigger]');
        if (!trigger || !this.contains(trigger)) {
          return;
        }

        this.syncCollapsiblePanel(trigger);
      });
    }

    syncCollapsiblePanel(trigger) {
      const currentGroup = trigger.closest('[data-collapsible-group]');
      if (!currentGroup) {
        return;
      }

      // collapsible.js fires on the button; this handler runs on the host during
      // the bubble phase, so classList already reflects the new state here.
      const isOpen = currentGroup.classList.contains('collapsible-is-open');
      const targetPanel = currentGroup.querySelector(':scope > [data-collapsible-target]');
      if (!targetPanel) {
        return;
      }

      if (!isOpen) {
        targetPanel.style.minHeight = '';
        targetPanel.style.height = '';
        const parentSubmenu =
          targetPanel.parentElement && targetPanel.parentElement.closest('.menu-drawer__submenu');
        if (parentSubmenu) {
          parentSubmenu.style.overflow = '';
        }
        return;
      }

      const parentList = currentGroup.closest('.menu-drawer__list');
      if (parentList) {
        parentList
          .querySelectorAll(':scope > [data-collapsible-group].collapsible-is-open')
          .forEach((group) => {
            if (group !== currentGroup) {
              group.classList.remove('collapsible-is-open');
            }
          });
      }

      targetPanel.scrollTop = 0;
      let parent = currentGroup.parentElement;
      while (parent) {
        if (parent.classList && parent.classList.contains('menu-drawer__submenu')) {
          parent.scrollTop = 0;
        }
        parent = parent.parentElement;
      }

      const parentSubmenu =
        targetPanel.parentElement && targetPanel.parentElement.closest('.menu-drawer__submenu');
      if (parentSubmenu) {
        const panelHeight = Math.max(parentSubmenu.offsetHeight, window.innerHeight);
        targetPanel.style.minHeight = panelHeight + 'px';
        parentSubmenu.style.overflow = 'visible';
      } else {
        const drawerInner = this.querySelector('.menu-drawer__inner');
        targetPanel.style.minHeight =
          (drawerInner ? drawerInner.offsetHeight : window.innerHeight) + 'px';
      }
    }
  }

  window.MenuDrawer = MenuDrawer;
  customElements.define('menu-drawer', MenuDrawer);
}
